import { API_URL } from "./env";

const API_BASE = API_URL;

export async function fetchPricingPlans() {
    const res = await fetch(`${API_BASE}/api/public/v1/pricing/plans`);
    const data = await res.json().catch(() => ({}));
    if (!res.ok || !data.success) {
        throw new Error(data.message ?? "Could not load pricing plans.");
    }
    return data.data;
}
